import { FormEventHandler } from "react";
import {
  FieldErrors,
  SubmitHandler,
  UseFormReturn,
  useForm,
} from "react-hook-form";
import { apiErrorToast } from "Utils";

type SaveFormData = {
  notify_on_completion: boolean;
  reprocess_affected: boolean;
};

type UseSavePolicyFormProps = {
  handleSave: (data: unknown) => void;
  onClose: () => void;
};

type UseSavePolicyForm = {
  errors: FieldErrors<SaveFormData>;
  onSubmit: FormEventHandler<HTMLFormElement>;
  methods: UseFormReturn<SaveFormData>;
};

const useSavePolicyForm = ({
  handleSave,
  onClose,
}: UseSavePolicyFormProps): UseSavePolicyForm => {
  const methods = useForm<SaveFormData>({
    defaultValues: {
      notify_on_completion: false,
      reprocess_affected: false,
    },
  });

  const {
    formState: { errors },
    handleSubmit,
  } = methods;

  const onSubmit: SubmitHandler<SaveFormData> = (data) => {
    try {
      handleSave(data);
      onClose();
    } catch (error) {
      apiErrorToast(error, "Could not save policy changes");
    }
  };

  return {
    onSubmit: handleSubmit(onSubmit),
    errors,
    methods,
  };
};

export default useSavePolicyForm;
